/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import PoliciesLogic from "../../../../Logic/Legal/PoliciesLogic";
import { Redirect } from "react-router-dom";
import { ErrorContainer, Loading } from "../../_common";
import { DocumentError } from "../../DocumentPage/DocumentPage";
import { t } from "../../../../i18n/i18n";

type Props = {
  tagQuery: string;
};

export default class LegalDocumentGetter extends React.Component<Props> {
  private readonly policiesLogic: PoliciesLogic;

  constructor(props: Props) {
    super(props);
    this.policiesLogic = new PoliciesLogic();
    this.policiesLogic.subscribe(() => this.setState({}));
  }

  componentDidMount(): void {
    this.policiesLogic.init();
  }

  getFirstLocalizedPolicyVersion = () => {
    return (this.policiesLogic.state.policies || [])
      .map((policy) => {
        if (!(policy.tags || []).map((tag) => tag.toLowerCase()).find((tag) => this.props.tagQuery === tag)) {
          return false;
        }
        return (policy.policyVersions || [])
          .map((policyVersion) => {
            return (policyVersion.localizedPolicyVersions || []).find(
              (localization) => localization.isDefaultSelection === true
            );
          })
          .filter(Boolean)[0];
      })
      .filter(Boolean)[0];
  };

  render() {
    if (this.policiesLogic.state.isLoading) {
      return <Loading />;
    }
    if (this.policiesLogic.state.error) {
      return <DocumentError error={this.policiesLogic.state.error} />;
    }
    const localizedPolicyVersion = this.getFirstLocalizedPolicyVersion();
    if (!localizedPolicyVersion) {
      return <ErrorContainer description={t("DocumentContainer.fileNotFound")} />;
    }
    return <Redirect to={`/${localizedPolicyVersion.id}`} />;
  }
}
